import getConfirmationModalConfig from './getConfirmationModalConfig';
import { actions as modalActions } from 'redux/modal';

/**
 * Project confirmation modal pattern (same as delete flows):
 * getConfirmationModalConfig({ title, message, confirmAction, rejectAction })
 */
export const openEntityLifecycleConfirm = ({ dispatch, closeModal, t, i18nPrefix, action, onConfirm }) => {
  const isLaunch = action === 'launch';
  const [config, element] = getConfirmationModalConfig({
    title: t(`${i18nPrefix}.${isLaunch ? 'launchModalTitle' : 'cancelModalTitle'}`),
    message: t(`${i18nPrefix}.${isLaunch ? 'launchConfirmationMessage' : 'cancelConfirmationMessage'}`),
    confirmAction: () => {
      closeModal();
      return onConfirm();
    },
    rejectAction: closeModal,
  });

  dispatch(modalActions.openModal(config, element));
};
